module.exports = __webpack_public_path__ + "static/03-291d8ae6b924ff3d4e79432f32cafa69.jpg";